import RealAccountSignup from './real-account-signup.jsx';

export default RealAccountSignup;
